import React, { Component } from 'react';
import { Row, Col, Card, CardHeader, CardBody, Button, ButtonGroup, Badge } from 'reactstrap';
import QRScan from './components/QRscanner';
import moment from 'moment';

import Config from './config';
import Language from './languages/es_ES';

class QRscan extends Component {
 constructor(props) {
  super(props)
  this.state = {
   token: this.props.qrscanner,
   ticket: false,
   watching: false
  }

  this.handleScan = this.handleScan.bind(this);
  this.handleValidate = this.handleValidate.bind(this);

  moment.locale(Language.locale);
 }

 reqAPI(route, method, params) {
  var headers = { 'accept': 'application/json' }
  var options = { method: 'GET', headers }
  if (this.state.token) headers['authorization-token'] = this.state.token;

  if (method !== undefined) {
   options = { method, headers, body: JSON.stringify(params) }
  }

  return new Promise((fulfill, reject) => {
   fetch(route, options).then((response) => {
    if (response.status === 401) toast.error(Language.Unauthorized, { autoClose: 15000 });
    if (response.status !== 200) throw new Error("Invalid response");
    return response.json()
   }).then((response) => {
    fulfill(response);
   }).catch((error) => {
    reject({ success: false, message: error });
   })
  })
 }

 handleScan(qrcode) {
  if (this.state.watching) {
   this.reqAPI(Config.apiURI + '/api/tickets/' + qrcode).then(ticket => {
    this.setState({ ticket, watching: false }, () => {
     window.scrollTo(0, 0);
    });
   })
  }
 }

 handleValidate(ID) {
  this.reqAPI(Config.apiURI + '/api/tickets/validate', 'POST', { ID }).then(ticket => {
   if (ticket.status) this.setState({ ticket: false, watching: false });
  })
 }

 render() {
  var status = parseInt(this.state.ticket.status);
  return (
   <Card>
    {
     this.state.watching ?
      <React.Fragment>
       <QRScan onFind={this.handleScan} />
       <Button className="pt-3 pb-3" style={{ width: '100%', position: 'fixed', bottom: 0 }} onClick={() => this.setState({ watching: false, ticket: false })}><h3>STOP</h3></Button>
      </React.Fragment>
      :
      <React.Fragment>
       {
        this.state.ticket ?
         parseInt(this.state.ticket.status) > 0 ?
          <ButtonGroup style={{ width: '100%', position: 'fixed', bottom: 0 }}>
           <Button color="danger" className="pt-3 pb-3" style={{ width: '50%' }} onClick={() => this.setState({ watching: false, ticket: false })}><h3>CANCELAR</h3></Button>
           <Button color="success" className="pt-3 pb-3" style={{ width: '50%' }} onClick={() => this.handleValidate(this.state.ticket.ID)}><h3>VALIDAR</h3></Button>
          </ButtonGroup>
          : <Button className="pt-3 pb-3" style={{ width: '100%', position: 'fixed', bottom: 0 }} onClick={() => this.setState({ watching: true, ticket: false })}><h3>Escanear</h3></Button>
         : <Button className="pt-3 pb-3" style={{ width: '100%', position: 'fixed', bottom: 0 }} onClick={() => this.setState({ watching: true, ticket: false })}><h3>Escanear</h3></Button>
       }

       {
        this.state.ticket ?
         <div>
          <CardHeader>
           <h3 className="text-center">{this.state.ticket.establishmentName}</h3>
           <h2 className="text-center">{this.state.ticket.productName}</h2>
          </CardHeader>
          <CardBody className={parseInt(this.state.ticket.status) > 0 ? 'bg-success' : 'bg-danger'}>
           <h2 className="mb-3 text-center">{this.state.ticket.ticketName.es_ES + ' ' + this.state.ticket.ticket_num}</h2>

           <Row>
            <Col xs="5" className="text-right"><h5>Fecha inicio:</h5></Col>
            <Col xs="7" className="text-left">
             <h5>{this.state.ticket.startDate ? moment(this.state.ticket.startDate).format('ddd, D MMMM H:mm') : null}</h5>
            </Col>
           </Row>

           <Row>
            <Col xs="5" className="text-right"><h5>Fecha validez:</h5></Col>
            <Col xs="7" className="text-left">
             <h5>{this.state.ticket.validity_time ? moment(this.state.ticket.validityDate).format('ddd, D MMMM H:mm') : null}</h5>
            </Col>
           </Row>

           <Row>
            <Col xs="5" className="text-right"><h5>Fin evento:</h5></Col>
            <Col xs="7" className="text-left">
             <h5>{this.state.ticket.finishDate ? moment(this.state.ticket.finishDate).format('ddd, D MMMM H:mm') : null}</h5>
            </Col>
           </Row>

           

           <Row>
            <Col xs="5" className="text-right"><h5>Cliente:</h5></Col>
            <Col xs="7" className="text-left">
             <h5>{this.state.ticket.clientName} {this.state.ticket.clientID?<small>({this.state.ticket.clientID})</small>:null}</h5>
            </Col>
           </Row>


           <div className="pt-3 pb-2 text-center" style={{ width: '100%', opacity: '.7' }}>
            {
             status > 0
              ? <h4>VALIDO<br />{this.state.ticket.usesLeft} {this.state.ticket.usesLeft>1?'USOS RESTANTES':'USO RESTANTE'}</h4>
              : status === -1 ? <h4>SIN VALIDEZ<br />SIN USOS RESTANTES</h4>
              : status === -2 ? <h4>SIN VALIDEZ<br />FUERA DE FECHA</h4>
              : status === -3 ? <h4>SIN VALIDEZ<br />FUERA DE FECHA</h4>
              : status === -4 ? <h4>SIN VALIDEZ<br />ESTABLECIMIENTO AJENO</h4>
              : <h4>SIN VALIDEZ</h4>
            }
           </div>
          </CardBody>
         </div>
         : null
       }
      </React.Fragment>
    }
   </Card>
  )
 }
}

export default QRscan;


// WEBPACK FOOTER //
// ./websources/qrscan.js